var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOverviewGreyscale8E44Ee66(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.667 19C10.667 17.3431 12.0101 16 13.667 16H50.3337C51.9905 16 53.3337 17.3431 53.3337 19V25.6H10.667V19Z",
    fill: "#DEE2E6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M54.667 46.3334C54.667 47.9902 53.3238 49.3334 51.667 49.3334L12.3337 49.3334C10.6768 49.3334 9.33366 47.9902 9.33366 46.3334L9.33366 24L54.667 24L54.667 46.3334Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.77832 19.1111C9.77832 17.9323 10.2466 16.8019 11.0801 15.9684C11.9136 15.1349 13.044 14.6666 14.2228 14.6666H49.7783C50.9571 14.6666 52.0875 15.1349 52.921 15.9684C53.7545 16.8019 54.2228 17.9323 54.2228 19.1111V48.0888C54.2228 49.2676 53.7545 50.398 52.921 51.2315C52.0875 52.065 50.9571 52.5333 49.7783 52.5333H14.2228C13.044 52.5333 11.9136 52.065 11.0801 51.2315C10.2466 50.398 9.77832 49.2676 9.77832 48.0888V19.1111Z",
    stroke: "#495057",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0003 32H18.667M18.667 39.4286H32.3813",
    stroke: "#495057",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOverviewGreyscale8E44Ee66);
export default __webpack_public_path__ + "static/media/overview-greyscale.8e44ee66.93fc7885000d3c9248bf837e7bbb8f9b.svg";
export { ForwardRef as ReactComponent };